import ajax from '@/utils/request'

// 详情
export const messageDetail = data => ajax('/api/message/get/', data, 'GET')
// 消息列表
export const messageList = data => ajax('/api/message/get/list/', data, 'POST')
// 导出消息
export const messageExport = data => ajax('/api/message/export', data, 'download')
